(function () {
    'use strict';

    angular
        .module('app')
        .factory('approvalAuthService', approvalAuthService);

        approvalAuthService.$inject = ['$http', '$q', '$interval', '$injector', '$mdDialog', '$localStorage', '$rootScope', '$timeout', '$location', 'loginService'];

    function approvalAuthService($http, $q, $interval, $injector, $mdDialog, $localStorage, $rootScope, $timeout, $location, loginService) {
        var service = {
            handleApprovalAuth: handleApprovalAuth,
            close: close,
            authenticate: authenticate
        };

        service.docs = [];

        function handleApprovalAuth(docs) {
            var deferred = $q.defer();
            service.docs = docs.list;

            //Ignore reset to start
            if (docs.mode === 143) {
                deferred.resolve(true)
            }
            else {
                getApprovalAuthenticationEnabled().then(function(resp) {
                    if (resp === true) {
                        showApprovalAuthentication().then(function(resp) {
                            deferred.resolve(resp);
                        });
                    }
                    else {
                        deferred.resolve(true);
                    }
                });
            }
            return deferred.promise;
        }

        function showApprovalAuthentication() {
            var deferred = $q.defer();
            $mdDialog.show({
                parent: angular.element(document.body),
                templateUrl: 'app/approvalauth/templates/approvalauth.html',
                controller: 'approvalauth',
                controllerAs: 'vm',
                skipHide: true,
                fullscreen: false,
                multiple: true
            }).then(function(response) {
                console.log(response);
                deferred.resolve(response);
            });

            return deferred.promise;
        }

        function close(param) {
            $mdDialog.hide(param);
        }

        function getApprovalAuthenticationEnabled() {
            var deferred = $q.defer();
            $http.get('../synergis.webapi/api/approval-authentication/enabled').then(function(resp) {
                deferred.resolve(resp.data);
            });
            return deferred.promise;
        }

        function authenticate(credentials) {
            var deffered = $q.defer();
            var requestModel = JSON.stringify({
                userId: $localStorage.userInfo.loginName,
                password: credentials.password,
                docModels: service.docs
            });
            $http.put('../synergis.webapi/api/approval-authentication/authenticate', requestModel).then(function (resp) {
                deffered.resolve(resp.data);
            }, function(error) {
                deffered.reject(error.data);
            });
            return deffered.promise;
        }
        return service;
    }
})();